import React from 'react';
import { FaFacebook, FaInstagram, FaLinkedinIn, FaTiktok, FaTelegram, FaWhatsapp, FaGoogle, FaEnvelope, FaVideo, FaImage, FaFileAlt, FaGlobe } from 'react-icons/fa';

// Map template IDs to their brand icon + brand color
export const TEMPLATE_ICONS = {
  facebook_ad:        { Icon: FaFacebook,    brandColor: '#1877F2' },
  instagram_ad:       { Icon: FaInstagram,   brandColor: '#E4405F' },
  linkedin_ad:        { Icon: FaLinkedinIn,  brandColor: '#0A66C2' },
  tiktok_ad:          { Icon: FaTiktok,      brandColor: '#000000' },
  telegram_ad:        { Icon: FaTelegram,    brandColor: '#0088CC' },
  whatsapp_ad:        { Icon: FaWhatsapp,    brandColor: '#25D366' },
  google_ads:         { Icon: FaGoogle,      brandColor: '#4285F4' },
  email_marketing:    { Icon: FaEnvelope,    brandColor: '#EA4335' },
  video_promo:        { Icon: FaVideo,       brandColor: '#FF0000' },
  video_ad:           { Icon: FaVideo,       brandColor: '#FF0000' },
  image_promo:        { Icon: FaImage,       brandColor: '#10B981' },
  product_description:{ Icon: FaFileAlt,     brandColor: '#F59E0B' },
  social_media:       { Icon: FaGlobe,       brandColor: '#8B5CF6' },
};

// Strip language suffixes like _es, _fr, _de etc. to get the base ad type
const getBaseAdType = (templateId) => {
  if (!templateId) return null;
  // Direct match first
  if (TEMPLATE_ICONS[templateId]) return templateId;
  // Strip 2-3 letter language suffix (e.g. instagram_ad_es → instagram_ad)
  const stripped = templateId.replace(/_[a-z]{2,3}$/, '');
  if (TEMPLATE_ICONS[stripped]) return stripped;
  // Try matching the prefix up to known ad types
  for (const key of Object.keys(TEMPLATE_ICONS)) {
    if (templateId.startsWith(key)) return key;
  }
  return null;
};

export const BrandIcon = ({ templateId, size = 20, className = '' }) => {
  const baseType = getBaseAdType(templateId);
  if (!baseType) return <FaGlobe size={size} color="#6B7280" className={className} />;
  const { Icon, brandColor } = TEMPLATE_ICONS[baseType];
  return <Icon size={size} color={brandColor} className={className} />;
};

export default BrandIcon;
